import axios from 'axios'
import util from '@/util/util'

const instance = axios.create({
  baseURL: process.env.VUE_APP_SERVICE_URL,
  headers: {
    authorization: `${localStorage.getItem('token')}`,
    shopObjectId: util.sanitizeShopObjectId(`${localStorage.getItem('shopObjectId')}`),
  },
})

export default instance
